var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewsRelease = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#232e48",
  viewBox: "-2 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#232e48",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M59 56.8c0 6.1-5 6.1-6.1 6.1H7.2c-1.1 0 4.9 0 4.9-6.1V3.9c0-1.1.9-2 2-2H57c1.1 0 2 .9 2 2v52.9Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.1 62.9h-3c-1.1 0-4.1-2-4.1-7.1V31c0-1.1.9-2 2-2h9M23 16h24M19 45h12M19 57h33.8M19 51.9h33.8M37 27h12.8M37 37h15.8M37 31.9h15.8M38 42h14v4.1H38zM20 25h10v11H20zM19 11.1h31.8"
}))));
export default SvgNewsRelease;